var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinesLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "36px",
    viewBox: "0 0 16 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "136A2CD0-B323-4906-9C55-1042101A8A16_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arveldus---Tehingud---Blankstate",
    transform: "translate(-561.000000, -285.000000)",
    stroke: "#D9D9D9",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(562.000000, 279.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lines---Left",
    transform: "translate(-0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,17 L3.24185123e-14,17",
    id: "Path-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,27 L7,34",
    id: "Path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,7 L7,1.2390089e-13",
    id: "Path-11"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinesLeft);
export default __webpack_public_path__ + "static/media/Lines - Left.f5acec3da7d6fb9a4879e3224a98b301.svg";
export { ForwardRef as ReactComponent };